import { Box, BoxProps, styled } from '@mui/material';
import { CheckmarkIcon, CloseIcon, ExclamationMarkIcon, InformationIcon } from '@synergy/theme-next';
import { ReactElement } from 'react';

export type StatusIconVariant = 'success' | 'warning' | 'error' | undefined;
export type FontSizeVariant = 'small' | 'medium' | 'large';

export const StyledBox = styled(Box, { shouldForwardProp: prop => prop !== 'variant' && prop !== 'fontSize' })<{
    variant: StatusIconVariant;
    fontSize?: FontSizeVariant;
}>(({ theme, variant, fontSize }) => ({
    color: theme.palette.common.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',

    fontSize: '14px',
    width: '18px',
    height: '18px',

    ...(fontSize === 'small' && {
        fontSize: '11px',
        width: '15px',
        height: '15px',
    }),
    ...(fontSize === 'large' && {
        fontSize: '19px',
        width: '22px',
        height: '22px',
    }),

    backgroundColor: theme.palette.primary.main,

    ...(variant === 'success' && {
        backgroundColor: theme.palette.success.main,
    }),
    ...(variant === 'warning' && {
        backgroundColor: theme.palette.warning.main,
    }),
    ...(variant === 'error' && {
        backgroundColor: theme.palette.error.light,
    }),
}));

export interface StatusIconProps extends BoxProps {
    variant?: StatusIconVariant;
    fontSize?: FontSizeVariant;
}

export const StatusIcon = (props: StatusIconProps): ReactElement => {
    const { variant, fontSize, ...boxProps } = props;

    return (
        <StyledBox variant={variant} fontSize={fontSize} {...boxProps}>
            {variant === 'success' ? (
                <CheckmarkIcon fontSize="inherit" strokeWidth="2.5" />
            ) : variant === 'error' ? (
                <CloseIcon fontSize="inherit" strokeWidth="2.5" />
            ) : variant === 'warning' ? (
                <ExclamationMarkIcon fontSize="inherit" strokeWidth="2.5" />
            ) : (
                <InformationIcon fontSize="inherit" strokeWidth="2.5" />
            )}
        </StyledBox>
    );
};
